import moment from "moment";
import { ListGroup, Overlay } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import { useHistory } from "react-router-dom";

const NotificationsOverlay = (props) => {
	const { target, open, handleClose, notifications } = props;
	const history = useHistory();

	return (
		<Overlay placement="bottom" rootClose={true} target={target} show={open} onHide={handleClose}>
			{({ placement, arrowProps, show: _show, popper, ...props }) => (
				<div {...props} style={{ ...props.style, zIndex: 3 }}>
					<div
						style={{
							marginTop: 16,
							marginLeft: 38,
							maxHeight: 500,
							background: "white",
							overflowY: "auto",
							boxShadow: "0px 3px 15px rgba(0,0,0,0.2)",
						}}
					>
						<ListGroup>
							<div style={{ padding: 16, fontWeight: 500 }}>
								Notifications
							</div>
							{notifications.length === 0 ? (
								<div style={{ fontWeight: 14 }}>
									No new notifications
								</div>
							) : (
								""
							)}
							{notifications.map((notification, index) => (
								<ListGroup.Item
									action
									key={index}
									onClick={() => {
										history.push(notification.route);
										handleClose();
									}}
								>
									<div style={{ fontSize: 14 }}>
										<ReactMarkdown
											children={notification.message}
										/>
									</div>
									<div
										style={{
											fontSize: 12,
											marginTop: "-0.8rem",
										}}
									>
										{moment(
											notification.processedTime
										).format("DD MMM, hh:mm A")}
									</div>
								</ListGroup.Item>
							))}
						</ListGroup>
					</div>
				</div>
			)}
		</Overlay>
	);
};

export default NotificationsOverlay;
